import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppFooter',
  setup() {
    return {
    }
  },
})
